<template functional>
  <transition name="fade">
    <div v-if="props.banner" class="category-banner" :class="data.staticClass">
      <img
        v-if="props.banner.imageUrl"
        class="banner-image"
        :src="props.banner.imageUrl"
        :alt="props.banner.altText"
      />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CategoryBanner',

  props: {
    /**
     * Banner object
     */
    banner: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.category-banner {
  // for wrapping element to provide line-height for <img>
  line-height: 0;
}

.banner-image {
  padding-top: 10px;
  width: 100%;
}
</style>
